import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';

@Injectable()
export class MenuserviceService {

  GetMyData$: Observable<any>;
  private GetMyDataSubject = new Subject<any>();

constructor() { 
  this.GetMyData$ = this.GetMyDataSubject.asObservable();
}

GetMyData(data) {
  
  this.GetMyDataSubject.next(data);
}
}



// WEBPACK FOOTER //
// ./src/app/common/menuservice.service.ts